import { DateTime } from "luxon";
import { Cell } from "../Cell";
import { ApplicantOrInvitee } from "../../types";
import { HugeiconsIcon } from "@hugeicons/react";
import { MinusSignIcon } from "@hugeicons-pro/core-stroke-rounded";

interface ApplicationSubmittedCellProps {
  applicant: ApplicantOrInvitee;
}

export const ApplicationSubmittedCell = ({
  applicant
}: ApplicationSubmittedCellProps) => {
  const isApplicant = "verifications" in applicant;

  return (
    <Cell isFirst isDataCell className="text-content-400">
      {isApplicant && applicant.application_submitted_at ? (
        DateTime.fromISO(applicant.application_submitted_at).toFormat(
          "MMM dd, yyyy 'at' h:mm a"
        )
      ) : (
        <HugeiconsIcon
          icon={MinusSignIcon}
          size={20}
          className="text-content-100"
        />
      )}
    </Cell>
  );
};
